var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.box},[_c('div',{class:_vm.$style.content},[_c('div',{class:_vm.$style.wrap},[_c('div',[_vm._v("\n        为了给大家带来更好的论坛体验，我们将于3月17日进行论坛停运维护，预计维护时间为14:00-18:00，如未能按时完成，论坛开启时间将会顺延。\n      ")]),_c('div',[_vm._v("给各位带来的不便，敬请谅解！")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }